export default __webpack_public_path__ + "static/media/kat_gril.b004d974.pdf";